import fb from '../../../../media/EarlyAccess/ic-fb.svg'
import fbDark from '../../../../media/EarlyAccess/ic-fb-dark.svg'
import ig from '../../../../media/EarlyAccess/ic-instagram.svg'
import igDark from '../../../../media/EarlyAccess/ic-instagram-dark.svg'
import x from '../../../../media/EarlyAccess/ic-twitter-x.svg'
import xDark from '../../../../media/EarlyAccess/ic-twitter-x-dark.svg'
import linkedIn from '../../../../media/EarlyAccess/ic-linkedin.svg'
import linkedInDark from '../../../../media/EarlyAccess/ic-linkedin-dark.svg'
import discord from '../../../../media/EarlyAccess/ic-discord.svg'
import discordDark from '../../../../media/EarlyAccess/ic-discord-dark.svg'
import yt from '../../../../media/EarlyAccess/ic-yt.svg'
import ytDark from '../../../../media/EarlyAccess/ic-yt-dark.svg'
import reddit from '../../../../media/EarlyAccess/ic-reddit.svg'
import redditDark from '../../../../media/EarlyAccess/ic-reddit-dark.svg'
import blog from '../../../../media/EarlyAccess/ic-blog.svg'
import blogDark from '../../../../media/EarlyAccess/ic-blog-dark.svg'
import tg from '../../../../media/EarlyAccess/ic-telegram.svg'
import tgDark from '../../../../media/EarlyAccess/ic-telegram-dark.svg'
import slideshare from '../../../../media/EarlyAccess/ic-slideshare.svg'
import slideshareDark from '../../../../media/EarlyAccess/ic-slideshare-dark.svg'
import { useIntl } from 'react-intl'
import brandingConfig from '../../../../config/brandingConfig'
import { useThemeMode } from '../../../../_metronic/partials'

export const EarlySocialMedia = () => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  return (<>
    <div className='mt-8 p-6 px-md-6 px-0 text-center'>
      <h3 className='font-size-18 font-semibold'>{formatMessage({ id: 'Stay Updated' })}</h3>
      <p className={`m-0 ${mode === 'dark' ? 'text-white' : 'text-muted'}`}>
        {formatMessage({ id: ` We'll notify you via email when your exclusive access is ready.` })}
      </p>
      <p className={`m-0 ${mode === 'dark' ? 'text-white' : 'text-muted'}`}>
        {formatMessage({ id: 'Meanwhile checkout our latest updates' })}</p>
    </div >

    <div className='text-center mt-6 w-100'>
      <div className='d-flex justify-content-center mt-4 gap-4'>
        <a href={brandingConfig.socialLinks.facebook} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? fbDark : fb}`} alt='facebook' />
        </a>

        <a href={brandingConfig.socialLinks.twitter} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? xDark : x}`} alt='twitter' />
        </a>

        <a
          href={brandingConfig.socialLinks.linkedin}
          target='_blank'
          rel='noreferrer'
        >
          <img src={`${mode === 'dark' ? linkedInDark : linkedIn}`} alt='LinkedIn' />
        </a>

        <a href={brandingConfig.socialLinks.instagram} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? igDark : ig}`} alt='LinkedIn' />
        </a>

        <a href={brandingConfig.socialLinks.telegram} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? tgDark : tg}`} alt='Telegram' />
        </a>
      </div>
    </div>

    <div className='text-center mt-2 w-100'>
      <div className='d-flex justify-content-center mt-4 gap-4'>
        <a href={brandingConfig.socialLinks.youtube} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? ytDark : yt}`} alt='youtube' />
        </a>

        <a href={brandingConfig.socialLinks.discord} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? discordDark : discord}`} alt='discord' />
        </a>

        <a href={brandingConfig.socialLinks.reddit} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? redditDark : reddit}`} alt='reddit' />
        </a>

        <a href={brandingConfig.socialLinks.blog} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? blogDark : blog}`} alt='blog' />
        </a>

        <a href={brandingConfig.socialLinks.slideShare} target='_blank' rel='noreferrer'>
          <img src={`${mode === 'dark' ? slideshareDark : slideshare}`} alt='slideshare' />
        </a>
      </div>
    </div>

    <div className='mt-6 text-center'>
      <p className='m-0 font-size-14'>{formatMessage({ id: 'Thank you for being an early supporter!' })}</p>
      <p className='m-0 font-size-14'>
        {formatMessage({ id: ` We can't wait for you to experience the future of record management.` })}
      </p>
    </div>
  </>)
}